import EditLeadSourceDialog from './EditLeadSourceDialog'

export default EditLeadSourceDialog
